export { fadeOutRightAnimation, fadeOutRightOnLeaveAnimation } from './fade-out-right.animation';
export { fadeOutUpAnimation, fadeOutUpOnLeaveAnimation} from './fade-out-up.animation';